module.exports = __webpack_public_path__ + "img/TEAMModellogo_tw.6145e01a.png";